import { styled } from 'ds';

export const Root = styled.div`
  ${({ theme }) => `
    padding: ${theme.spacing(12)} 0;
    width: 100%;
    .carousel-shadow-root div.view-pager-rail {
      padding-right: 0;
    }

    .slide-btn[dir="next"] {
      left: -${theme.spacing(2)};
    }
    .slide-btn[dir="prev"] {
      right: -${theme.spacing(2)};
    }
  `};
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(4)} 0;
  `}
`;

export const Header = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${theme.spacing(2)};
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    flex-direction: column;
    align-items: start;
    gap: ${theme.spacing(1.5)};
  `}
`;

export const MobileList = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
    .blog-card__root {
      width: 100%;
    }
  `}
`;
